export const initialState = {
	selectedPipe: undefined,
	selectedPipeChangesClone: undefined
};

export default initialState;
